<!--
 * @Description: 嘉宾详情PC版
 * @Author:  
 * @Date: 2024-07-31 10:36:25
 * @LastEditTime: 2024-09-10 11:55:46
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div>
      <page-header>{{'嘉宾详情' | dealLanguage('Speaker situation')}}</page-header>
      <div class="flex-wrapper">
        <div class="flex-left">
          <div class="guest-photo">
            <img :src="guestInfo.logoUrl | logo_show" />
          </div>
          <!-- <div class="comp-logo">
            <img src="https://cdn.vbdata.cn/upload/entity/98e1dc77838bd21fe216a95ffb30e17084.PNG" />
          </div> -->
        </div>
        <div class="flex-right">
          <div class="guest-info">
            <div class="guest-name"><span></span>{{guestInfo.name | dealLanguage(guestInfo.enName)}}</div>
            <div class="guest-title" v-html="filter.dealLanguage(guestInfo.companyPosition, guestInfo.enCompanyPosition)"></div>
            <div class="guest-desc" v-html="filter.dealLanguage(guestInfo.desc, guestInfo.enDesc)"></div>
          </div>
        </div>
      </div>
      <page-header>{{'嘉宾参与议程' | dealLanguage('Meeting agenda with speaker participation')}}</page-header>
      <div class="flex-wrapper">
        <div class="froum-list">
          <div class="froum-wrapper" v-for="item in froum_list" :key="item.activityId" :id="item.activityId">
            <div class="froum-base">
              <p>{{item.dateName}}-{{item.activityName}}</p>
              <p><i class="iconfont">&#xe672;</i>{{item.forumPlace}}</p>
            </div>
            <div class="agendas">
              <div class="agenda-item" v-for="(aitem, aindex) in item.agendas">
                <p class="agenda-title">
                  <span class="time">{{aitem.agendaStartTime | time_moment('HH:SS')}}</span>
                  <span class="title">{{aitem.agendaTitle}}</span>
                </p>
                <div class="guest-list">
                  <div class="guest-item" v-for="(gitem, gindex) in aitem.guests">
                    <div class="guest-photo" @click="goGuestDetail(gitem.id)">
                      <img :src="gitem.logoUrl | logo_show" class="photo-img" />
                      <!-- <div class="comp-logo">
                        <img src="https://cdn.vbdata.cn/upload/entity/98e1dc77838bd21fe216a95ffb30e17084.PNG" />
                      </div> -->
                    </div>
                    <div class="guest-info">
                      <div class="guest-name" @click="goGuestDetail(gitem.id)"><span></span>{{gitem.name | dealLanguage(gitem.enName)}}</div>
                      <!-- <div class="guest-title"></div> -->
                      <div class="guest-desc">{{gitem.companyPosition | dealLanguage(gitem.enCompanyPosition)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <speaker-item v-for="g_item in item.guestDtoList" :key="item.activityId + g_item.id" :itemDetail="g_item"></speaker-item> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import { getGuestDetail } from '@/service/vbef'
import filter from 'js/filter'
export default {
  inject: ['globalInsertRecords'],
  metaInfo(){
    return {
      title: this.language == 'zh' ? '嘉宾详情' : 'Speaker situation', 
    }
  },
  data() {
    return {
      filter,
      guestInfo: '',
      froum_list: [],
      loading: false
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      user_key: (state) => state.user_key,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },

  created() {
    this.getGuestDetail()
  },

  mounted() {},

  methods: {
    async getGuestDetail() {
      this.loading = true
      let res = await getGuestDetail({
        guestId: this.$route.params.id,
        actId: this.activityId,
        languageType: this.language == 'zh' ? 0 : 1
      })
      if (res.code == 0) {
        this.$set(this.$data, 'guestInfo', res.data.guestDto)
        this.$set(this.$data, 'froum_list', res.data.activities)
        this.froum_list.map((a) => {
          if (a.forumPlaceJson) {
            let place = JSON.parse(a.forumPlaceJson)
            let forum = ''
            if (place.level1_show == 1 && place.place_level1) forum += place.place_level1
            if (place.level2_show == 1 && place.place_level2) forum += ' ' + place.place_level2
            if (place.level3_show == 1 && place.place_level3) forum += ' ' + place.place_level3
            this.$set(a, 'forumPlace', forum)
          } else {
            this.$set(a, 'forumPlace', '')
          }
        })
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      this.loading = false
    },
    goGuestDetail(guest_id) {
      this.globalInsertRecords({
        contentId: guest_id,
        contentType: 152,
        viewType: 1
      })
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: guest_id,
        },
      })
    },
  },
  watch: {
    '$route.params.id'(newValue) {
      this.getGuestDetail()
    },
  }
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/forum-list-pc.styl'
.main-container
  position: relative
>>>.flex-left
  flex 0 0 230px !important
  max-width 230px !important
  min-width 230px !important
  position relative
  .guest-photo
    width 230px
    height 230px
    img
      width 100%
      height 100%
      object-fit cover
  .comp-logo
    position absolute
    right 0
    bottom -30px
    width 80px
    height 80px
    background #FFFFFF
    box-shadow 0px 3px 8px 0px rgba(0, 0, 0, 0.16)
    display flex
    align-items center
    justify-content center
    img
      max-width 100%
      max-height 100%
.flex-right
  .guest-info
    .guest-name
      font-size 18px
      color #333333
      display flex
      align-items center
      span
        display inline-block
        width 2px
        height 20px
        background #c8161d
        margin-right 4px
    .guest-title
      margin-top 20px
      font-size 16px
      color #666666
    .guest-desc
      font-size 16px
      color #666666
      line-height 30px
      text-align justify
      padding-top 20px
      height: 166px
      display -webkit-box
      overflow hidden
      text-overflow ellipsis
      word-break break-all
      -webkit-box-orient vertical
      -webkit-line-clamp 5
.froum-list
  width: 1200px
  .guest-list
    .guest-item
      display flex
      flex 0 0 285px !important
      margin-bottom: 20px
      &:not(:nth-of-type(4n))
        margin-right: 20px
      .guest-desc
        max-width: 165px
</style>